import React, { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress, makeStyles } from '@material-ui/core';

// Estilos CSS
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifycontent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '150px',
        padding: theme.spacing(35),
        color: '#E02A58',
    },
}));

/**
 * @desc Componente de vista para login de la aplicación
 * @returns {JSX.Element}
 * @constructor
 */
function LoadingScreen() {
    const classes = useStyles();

    useEffect(() => {
        NProgress.start();

        return () => {
            NProgress.done();
        };
    }, []);

    return (
      <div className={classes.root}>
        <Box width={80}>
          <CircularProgress color="inherit" />
        </Box>
      </div>
    );
}

export default LoadingScreen;
